import { Injectable } from '@angular/core';
import {ObjectService} from "./abstractions/objects/object.service.abstract";
import {Observable} from "rxjs";
import {ITaskOptions} from "../../models/task-options.model";

@Injectable({
  providedIn: 'root'
})
export class TasksService extends ObjectService<ITaskOptions> {
  protected api = '/completions/'; // Base URL for the client API

  runTaskAsync(taskId: string, payload: any): Observable<any> {
    return this.http.post<any>(this.getEndpoint() + taskId + '/run', payload);
  };

  reportAsync(taskId: string, startDate?: string, endDate?: string): Observable<any> {
    return this.http.get<any>(this.getEndpoint() + taskId + '/report?startDate=' + startDate + '&endDate=' + endDate);
  }

  reportAllAsync(startDate?: string, endDate?: string): Observable<any> {
    return this.http.get<any>(this.getEndpoint() + 'report?startDate=' + startDate + '&endDate=' + endDate);
  }

  getTaskAsync(id: string, taskId: any) {
    return this.http.get<any>(this.getEndpoint() + id + "/task/" + taskId);
  }

  getAllTasksAsync(id: string) {
    return this.http.get<any>(this.getEndpoint() + id + "/tasks");
  }
}